import { NotificationActionKind, type NotificationDto } from "@/api/notifications";
import { type EmbeddedNotification, MAX_NOTIFICATION_BODY_LENGTH, MAX_NOTIFICATION_TITLE_LENGTH, parseEmbeddedNotification } from "./protocol";

/** 只把通知展示所需的字段交给宿主，跳转限于当前仍可访问的嵌入工单详情。 */
export function toEmbeddedNotification(notification: NotificationDto): EmbeddedNotification | null {
  const path =
    notification.isTargetAccessible && notification.actionKind === NotificationActionKind.TicketDetail && notification.actionTargetId
      ? `/embedded/tickets/${encodeURIComponent(notification.actionTargetId)}`
      : null;

  return parseEmbeddedNotification({
    cursor: notification.cursor,
    notificationId: notification.notificationId,
    type: notification.type,
    severity: notification.severity,
    title: notification.title.slice(0, MAX_NOTIFICATION_TITLE_LENGTH),
    body: notification.body.slice(0, MAX_NOTIFICATION_BODY_LENGTH),
    creationTime: notification.creationTime,
    path,
  });
}
